import React from 'react';
import { PageLayout } from 'containers/layout';
import ForgotPasswordForm from 'containers/auth/ForgotPasswordForm';

function ForgotPasswordPage() {
  return (
    <PageLayout hideHeader>
      <ForgotPasswordForm />
    </PageLayout>
  );
}

export default ForgotPasswordPage;
